exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-E2[data-v-5300365c] {\n  color: #4A90E2;\n}\n.mark[data-v-5300365c] {\n  display: inline-block;\n  width: 0.75rem;\n}\n.mark img[data-v-5300365c] {\n  width: 100%;\n}\n.padding2-top[data-v-5300365c] {\n  padding-top: 0.1rem;\n}", ""]);

// exports
